/** @format */

export interface ProductAvailability {
  inStoreInventoryMessage?:
    | 'OutOfStock'
    | 'InStock'
    | 'LowStock'
    | 'AvailableNearBy'
    | 'ShipToStore';
  onlineInventoryMessage: 'OutOfStock' | 'InStock' | 'LowStock';
}

export interface AvailabilityMessage {
  class: string;
  icon: string;
  text: string;
}
